var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":"vendor-locations-viewer","ok-only":"","title":("" + (_vm.locations.length == 0 ? 'No locations for this vendor': ''))}},[_c('locations-viewer',{attrs:{"locations":_vm.locations}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }